class PaymentBillsService {
    constructor ($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
      this.$q = $q;
      this.$http = $http;
      this.ngAuthSettings = ngAuthSettings;
      this.$httpParamSerializerJQLike= $httpParamSerializerJQLike;
    }
  
    getItemsToFact(documentNumber) {

      return this.$q((resolve, reject) => {
        this.$http({
          method: 'GET',
          url: this.ngAuthSettings.apiServiceBaseUri + '/recaudos/recaudos/facturas-pendientes-co?terceroDocumento=' + documentNumber,
          cache: true
        }).then((response) => {
          resolve(response.data);
        }, (reason) => {
          reject(reason);
        });
      });
  
    }
  }
  
  PaymentBillsService.$inject = ['$q','$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];
  
  export default PaymentBillsService;
  


/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/payments-advances/payment-bills/payment-bills.service.js
 **/